import CollapsibleTable from './CollapsibleTable';



export default CollapsibleTable;
